import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosTomador from './FiltrosAdicionadosTomador'
import FiltroTomador from './FiltroTomador'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroTomador = () => (
  <Filtro PainelFiltro={FiltroTomador}/>
);

const PainelFiltrosTomador = () => (
  <PainelFiltragem
    Filtro={PainelFiltroTomador}
    FiltrosAdicionados={FiltrosAdicionadosTomador}/>
)

export default PainelFiltrosTomador
